<template>
  <div class="customDetailComponents">
    <div class="toConfigure">
      <div class="customDetailFrom" v-if="fromArray.length !== 0">
        <FormLayout :defaultColumn="defaultColumn" ref="FormLayout" :defaultconfig="fromConfig"></FormLayout>
      </div>
      <div class="customDetailTable">
        <div class="page_content">
          <div class="page_box">
            <Page
              size="small"
              :page-size-opts="pageSizeOpts"
              :total="totalRowCount"
              show-elevator
              show-sizer
              show-total
            />
            <span class="page_btn">【删除明细】</span>
            <span class="page_btn">【导入】</span>
            <span class="page_btn">【导出】</span>
          </div>
          <div class="search_box">
            <Select v-model="model1" style="width:120px;margin-right:8px;" placeholder="查询条件">
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
            <Input v-model="searchValue" style="width:160px" search>
              <span slot="prepend">搜索</span>
            </Input>
          </div>
        </div>
        <Table style="margin-top:8px;" height="200" :columns="columns" :data="data"></Table>
      </div>
    </div>
    <div class="customizedPage"></div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    fromArray: {
      type: Array,
      default: () => []
    },
    pageSizeOpts: {
      type: Array,
      default: () => [10, 20, 30, 50, 100]
    },
    totalRowCount: {
      type: Number
    },
    row: {
      type: Array,
      default: () => []
    },
    tabth: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    fromConfig() {
      let newFromArray = [];
      this.fromArray.map((item, index) => {
        newFromArray[index] = {
          row: 1,
          col: 1,
          show: true,
          item: {
            type: "Input", // 组件类型
            required: item.isnotnull, // 是否必填
            label: item.name,
            props: {
              placeholder: "",
              value: "",
              regularMessage: "", // 报错提示
              disabled: item.readonly,
              regx: /[0-9]/g // 校验规则
            },
            event: {
              "on-change": e => {}
            }
          }
        };
      });
      return newFromArray;
    },
    data() {
      this.row.forEach(ele => {
        Object.keys(ele).forEach(item => {
          ele[item] = ele[item].val;
        });
      });
      return this.row;
    },
    columns() {
      this.tabth.forEach(ele => {
        ele.title = ele.name;
        ele.key = ele.colname;
      });
      let cc = this.tabth.filter(item => !item.isfilter);
      const columns = [
        {
          type: "selection",
          width: 30,
          fixed: "left",
          align: "center"
        },
        {
          type: "index",
          width: 40,
          align: "center",
          fixed: "left",
          renderHeader: (h, params) => {
            return h("span", "序号");
          }
        }
      ];
      cc = columns.concat(this.tabth);

      cc.forEach(ele => {
        if (ele.fkdisplay && ele.fkdisplay == "drp") {
          ele.render = this.InputRender();
        } else if (ele.fkdisplay && ele.fkdisplay == "mrp") {
          ele.render = this.SelectRender();
        }
      });
      console.log(cc);
      return cc;
    }
  },
  data() {
    return {
      fflinkdata: {
        data: {},
        totalRowCount: 0
      },
      defaultColumn: 4,
      config: [],
      searchValue: "",
      cityList: [
        {
          value: "New York",
          label: "New York"
        },
        {
          value: "London",
          label: "London"
        },
        {
          value: "Sydney",
          label: "Sydney"
        },
        {
          value: "Ottawa",
          label: "Ottawa"
        },
        {
          value: "Paris",
          label: "Paris"
        },
        {
          value: "Canberra",
          label: "Canberra"
        }
      ],
      model1: ""

      //   config: [
      //     {
      //       item: {
      //         type: "Input", // 组件类型
      //         required: true, // 是否必填
      //         label: "input组件",
      //         props: {
      //           placeholder: "后台字段",
      //           value: "666",
      //           regularMessage: "请输入666", // 报错提示
      //           regx: /[0-9]/g // 校验规则
      //         },
      //         event: {
      //           "on-change": e => {
      //             this.defaultColumn = 2;
      //           }
      //         }
      //       }
      //     },
      //     {
      //       show: true, // 是否显示隐藏
      //       row: 1, // 行高
      //       col: 1, // 列宽
      //       item: {
      //         type: "Input", // 组件类型
      //         required: true, // 是否必填
      //         label: "Input组件",
      //         props: {
      //           placeholder: "后台字段",
      //           value: "",
      //           regularMessage: "请输入666" // 报错提示
      //         },
      //         event: {
      //           "on-change": e => {}
      //         }
      //       }
      //     },
      //     {
      //       show: true, // 是否显示隐藏
      //       row: 1, // 行高
      //       col: 1, // 列宽
      //       item: {
      //         type: "Select", // 组件类型
      //         required: true,
      //         label: "Select组件",
      //         props: {
      //           placeholder: "后台字段",
      //           options: [
      //             {
      //               value: "New York",
      //               label: "New York"
      //             },
      //             {
      //               value: "London",
      //               label: "London"
      //             },
      //             {
      //               value: "Sydney",
      //               label: "Sydney"
      //             },
      //             {
      //               value: "Ottawa",
      //               label: "Ottawa"
      //             },
      //             {
      //               value: "Paris",
      //               label: "Paris"
      //             },
      //             {
      //               value: "Canberra",
      //               label: "Canberra"
      //             }
      //           ]
      //         },
      //         event: {
      //           "on-change": e => {
      //             console.log(e);
      //           }
      //         }
      //       }
      //     }
      //   ],
    };
  },
  mounted() {},
  methods: {
    DropMultiSelectFilterRender() {
      return (h, params) =>
        h("DropMultiSelectFilter", {
          props: {
            data: this.fflinkdata.data,
            totalRowCount: this.fflinkdata.totalRowCount,
            pageSize: 10,
            showColnameKey: "show",
            dataEmptyMessage: "数据加载中...", // 无数据的提示
            columns: ["ENAME", "ECODE"], // 展现的组
            AutoData: []
          },
          on: {
            "on-page-change": value => {},
            "on-input-value-change": value => {},
            "on-popper-show": e => {
              let searchdata = {
                isdroplistsearch: true,
                refcolid: 1700804609,
                startindex: 0,
                range: 10
              };
              let param = new URLSearchParams();
              param.append("searchdata", JSON.stringify(searchdata));
              axios({
                url: "/p/cs/QueryList",
                method: "post",
                data: param
              }).then(res => {
                if (res.data.code === 0) {
                  this.fflinkdata.totalRowCount = res.data.datas.totalRowCount;
                  this.fflinkdata.data = {
                    start: 0,
                    tabth: [
                      {
                        colname: "ID",
                        name: "ID",
                        show: false
                      },
                      {
                        colname: "ECODE",
                        name: "名称",
                        show: true
                      },
                      {
                        colname: "ENAME",
                        name: "邮箱",
                        show: true
                      }
                    ],
                    row: res.data.datas.row
                  };
                }
              });
            },
            "on-fkrp-selected": e => {}
          }
        });
    },
    SelectRender() {
      return (h, params) =>
        h(
          "Select",
          {
            style: {
              width: "100px"
            },
            props: {
              transfer: true,
              clearable: true,
              value: ""
            },
            on: {
              "on-change": value => {}
            }
          },
          [1, 2, 3, 4].map(item => {
            return h("Option", {
              props: {
                value: item,
                label: item
              }
            });
          })
        );
    },
    InputRender() {
      return (h, params) =>
        h("Input", {
          style: {
            width: "100px"
          },
          props: {
            clearable: true,
            value: ""
          },
          on: {
            "on-change": value => {}
          }
        });
    }
  }
};
</script>
<style lang="less">
.customDetailComponents {
  .customDetailFrom {
    padding: 8px 10px 8px 0;
    background-color: #f8f8f8;
  }
  .customDetailTable {
    margin-top: 8px;
    padding: 10px 15px;
    .page_content {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .page_box {
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        .page_btn {
          margin-left: 10px;
          color: #2d8cf0;
          cursor: pointer;
        }
      }
      .search_box {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: row;
      }
    }
  }
}
</style>